import { POSITION, TYPE } from 'vue-toastification';

import ToasterCloseIcon from '@/components/toaster/ToasterClose.vue';
import ToasterIconError from '@/components/toaster/ToasterIconError.vue';
import ToasterIconInfo from '@/components/toaster/ToasterIconInfo.vue';
import ToasterIconSuccess from '@/components/toaster/ToasterIconSuccess.vue';
import ToasterIconWarning from '@/components/toaster/ToasterIconWarning.vue';

const MAX_TOASTS = 5;
const TIMEOUT_DELAY = 8000;

/**
 * Allows to set the position based on media and dir of app
 */
function getPosition(isRtl: boolean) {
  const desktopPosition = isRtl ? POSITION.TOP_LEFT : POSITION.TOP_RIGHT;
  return window.matchMedia(`(max-width: 960px)`).matches ? POSITION.BOTTOM_CENTER : desktopPosition;
}

/**
 * Allows to display only the last X toasts - the older ones will be removed
 */
function filterToasts(toasts) {
  const startIndex = toasts.length - MAX_TOASTS;
  if (toasts.length >= MAX_TOASTS) {
    toasts = toasts.filter((toast, index) => {
      return index >= startIndex || !toast.timeout;
    });
  }
  return toasts;
}

/**
 * Manage toast before it is displayed:
 * If toast is not closable, automatically set timeout to 0 so that it does not close
 */
function filterBeforeCreate(toast) {
  if (!toast.closeButton) toast = { ...toast, closeOnClick: false };
  return toast;
}

export function ToastOptions(isRtl = false) {
  return {
    toastClassName: 'af-toaster',
    bodyClassName: 'af-toaster-body text-body-3 font-weight-light',
    containerClassName: 'af-toaster-container',
    closeButtonClassName: 'af-toaster-close',
    timeout: TIMEOUT_DELAY,
    newestOnTop: true,
    position: getPosition(isRtl),
    shareAppContext: true,
    hideProgressBar: true,
    rtl: isRtl,
    filterToasts,
    filterBeforeCreate,
    toastDefaults: {
      [TYPE.ERROR]: {
        closeButton: ToasterCloseIcon,
        icon: ToasterIconError
      },
      [TYPE.INFO]: {
        closeButton: ToasterCloseIcon,
        icon: ToasterIconInfo
      },
      [TYPE.SUCCESS]: {
        closeButton: ToasterCloseIcon,
        icon: ToasterIconSuccess
      },
      [TYPE.WARNING]: {
        closeButton: ToasterCloseIcon,
        icon: ToasterIconWarning
      }
    }
  };
}
